(function(){

/* CODE FOR MENU */

var btn = document.getElementsByClassName("btn");
var menu_container = document.getElementsByClassName("menu_container");
var close_menu =  document.getElementsByClassName("close_menu");
var toggle = [];

for(let i = 0; i < btn.length; i++){
	toggle[i] = 0;
	btn[i].onclick = function(){
		if(toggle[i] == 0){
			for(let i = 0; i < btn.length; i++){
				toggle[i] = 0;
				menu_container[i].style.display = "none";
              	for(let i = 0; i < bikini_img.attributes.length; i++){		// REMOVES TITLE CARD 
					if(bikini_img.attributes[i].value == "https://cdn.shopify.com/s/files/1/1345/8497/files/ToxicByYouCoverPage.jpg?v=1616011407"){
						bikini_img.attributes[i].value = " ";
					}
				} // END NEW CODE
			}
			toggle[i] = 1;
			menu_container[i].style.display = "block";
		}else{
			toggle[i] = 0;
			menu_container[i].style.display = "none";
		}
	}
}

for(let i = 0; i < close_menu.length; i++){
	close_menu[i].onclick = function(){
		toggle[i] = 0;
		menu_container[i].style.display = "none";
	}
}

/* CODE FOR BIKINI IMG */

var fabric_name = document.getElementById("fabric_name");
var fabric_options = document.getElementsByClassName("fabric_options");
var nodes = [];
var img;

var bikini_img = document.getElementById("bikini_img");


for(let i = 0; i < fabric_options.length; i++){
	nodes[i] = fabric_options[i].childNodes;
	for(let x = 0; x < nodes[i].length; x++){
		if(x % 2 == 1){
			nodes[i][x].onclick = function(){
				img = nodes[i][x].getAttribute("image");
				bikini_img.setAttribute("xlink:href",img);
				//fabric_name.innerHTML = nodes[i][x].innerHTML;
              	fabric_name.innerHTML = nodes[i][x].getAttributeNode("name").value;
              	console.log(fabric_name.innerHTML = nodes[i][x].getAttributeNode("name").value)
				menu_container[0].style.display = "none";
				toggle[0] = 0;
			}
		}
	}
}
/* CODE FOR CRYSTAL IMG */

var crystals = document.getElementsByClassName("crystals");
var crystals_2 = document.getElementsByClassName("crystals_2");
var crystal_options = document.getElementsByClassName("crystal_options");
var crystal_nodes = [];
var crystal_img;
var crystal_name = document.getElementsByClassName("crystal_name")

var counter = 0;

for(let i = 0; i < fabric_options.length; i++){
	crystal_nodes[i] = crystal_options[i].childNodes;
	for(let x = 0; x < crystal_nodes[i].length; x++){
		if(x % 2 == 1){
			crystal_nodes[i][x].onclick = function(){
				crystal_img = crystal_nodes[i][x].getAttribute("image")
				if(counter == 3){
					menu_container[1].style.display = "none";
					toggle[1] = 0;
				}
				if(counter == 4){
					counter = 0;
				}
				if(counter < 4){
					crystals[counter].setAttribute("xlink:href",crystal_img)
					crystals_2[counter].setAttribute("xlink:href",crystal_img)
					crystal_name[counter].innerHTML = crystal_nodes[i][x].getAttribute("name");
					counter += 1;
				}
			}
		}
	}
}
})();